// The homepage is now served as a static HTML file (see public/index.html),
// matching the rest of the site's static-page architecture.
// React is only mounted if a #root element is present (none on the static homepage),
// so no React bundle CSS/markup interferes with the static design.
const root = document.getElementById("root");
if (root) {
  Promise.all([
    import("react"),
    import("react-dom/client"),
    import("@/index.css"),
    import("@/App"),
  ]).then(([React, ReactDOM, _css, AppMod]) => {
    const App = AppMod.default;
    ReactDOM.createRoot(root).render(
      React.createElement(React.StrictMode, null, React.createElement(App))
    );
  });
}
